import React from "react";
import PropTypes from "prop-types";
import { isBreakpoint } from "../utility/WindowSizeHooks"
import PublicCatalogLayout from "../layouts/PublicCatalogLayout"
import ItemCard from "../items/components/ItemCard"
import { isJaguar, isSuperadmin } from "../utility/UserUtils"
import KitCard from "../kits/KitCard";
import { 
  Card,
  CardContent,
  CardActions,
  Typography,
  Button
}  from "@mui/material";
class InventoryReportsDashboard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedGroup: "All",
    }
  }


  renderItems() {
    let { items, user } = this.props;
    return this.getSortedItems().sort((a,b) => (a.name < b.name ? -1 : 1)).filter(item=> !item.variant_of_id).map(item => (
      <ItemCard key={`item-card-${item.id}`} inventory={true} item={item} user={user}/>
    ))
  }

  renderKits() {
    let { user } = this.props;
    return this.getSortedKits().map(kit => (
      <KitCard inventory={true} kit={kit} user={user}/>
    ))
  }

  getSortedItems(){
    let { items } = this.props;
    const { selectedGroup } = this.state;
    if(selectedGroup=="All"){

    }else if (selectedGroup == "Other"){
      items = items.filter(item => !item.category || !item.category.group_name)
    }else {
      items = items.filter(item=> item.category && item.category.group_name == selectedGroup)
    }
    items = items.filter(item => item.owned > 0);
    return items;
  }

  getSortedKits() {
    let { kits } = this.props;
    return kits.sort((a, b) => 
      (a.name < b.name ? -1 : 1)
    )
  }

  getFullSquareFootage(){
    const { renter } = this.props;
    const size = renter.stored_volume || 0
    return Math.round(size/1728)
  }

  getRentersFullPrice(){
    const { renter } = this.props;
    const price = renter.monthly_cost || 0
    return (price * 12).toFixed(2);
  }



  renderReports() {
    const { renter } = this.props;
    return (
      <div className="col-xs-12 col-md-4">
      <Card sx={{ minWidth: 275 }}>
        <CardContent>
          <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>
            Complete Inventory Report
          </Typography>
        </CardContent>
        <CardActions>
          <Button size="small" href={`/warehouse/reports/renter_full_billing?id=${renter.id}`}>Download</Button>
        </CardActions>
      </Card>
      </div>
    )
  }

  render() {
    const { renter } = this.props;
    const {selectedGroup} = this.state
    return (
      <PublicCatalogLayout
        classNames={{container: 'inventory-dashboard'}}
        className="inventory-dashboard"
        renter={renter}
        currentPage={"inventory-"+renter.id}
        
        {...this.props}
      >
        <div className="row">
          <div className="col-xs-12">
          <h1 class="catalog-h1 mb-4">Reports</h1>
          <div className="row">
          {this.renderReports()}
          </div>
          </div>
        </div>
      </PublicCatalogLayout>
    );
  }
}

InventoryReportsDashboard.propTypes = {

};

export default InventoryReportsDashboard;
